import React from 'react'
import { useNavigate } from 'react-router-dom'

interface Iprops {
  agentListing: any
}

const AgentListing: React.FC<Iprops> = ({ agentListing }) => {
  const navigate = useNavigate()
  const handleNavigate = (agentId: any) => {
    navigate(`/report/agent-dashboard/${agentId}`)
  }

  return (
    <div className='col-xl-8'>
      <div className='card card-xl-stretch mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>AGENT LISTINGS</span>
            <span className='text-muted mt-1 fw-semibold fs-7'></span>
          </h3>
        </div>

        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table align-middle gs-0 gy-3'>
              <thead>
                <tr className='fs-7 fw-bold text-gray-500 border-bottom-0'>
                  <th className='p-0 pb-3 min-w-100px text-start'>AGENT NAME</th>
                  <th className='p-0 pb-3 min-w-100px pe-3'>TOTAL CONVERSATION</th>
                  <th className='p-0 pb-3 min-w-100px pe-3'>AVG FIRST RESPONSE TIME</th>
                  <th className='p-0 pb-3 min-w-100px pe-3'> AVG RESOLUTION TIME</th>
                  <th className='p-0 pb-3 min-w-100px pe-3'>RESOLUTION PERCENTAGE</th>
                  <th className='p-0 pb-3 w-100px pe-3'> RESOLVED</th>
                  <th className='p-0 pb-3 w-50px pe-3 '> ESCALATED</th>
                </tr>
              </thead>
              <tbody>
                {agentListing.map((agent: any, index: any) => (
                  <tr key={agent.agentId}>
                    <td>
                      <div
                        className='d-flex align-items-center'
                        onClick={() => handleNavigate(agent.agentId)}
                      >
                        <div className='symbol symbol-50px me-3'>
                          <img src={agent.image} alt={agent.name} className='cursor-pointer' />
                        </div>
                        <div className='d-flex justify-content-start flex-column cursor-pointer'>
                          <div className='text-gray-800 fw-bold text-hover-primary mb-1 fs-6'>
                            {agent.name}
                          </div>
                          <span
                            className={`badge py-1 ${
                              agent.status === 'ACTIVE'
                                ? 'badge-light-success'
                                : 'badge-light-danger'
                            }`}
                          >
                            {agent.status}
                          </span>
                          {/* <span className="text-gray-500 fw-semibold d-block fs-7"></span> */}
                        </div>
                      </div>
                    </td>
                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6 '>
                        {agent.totalConversations}
                      </span>
                    </td>
                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6'>
                        {agent.avgFirstResponseTimeSec}S
                      </span>
                    </td>

                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6'>
                        {agent.avgResolutionTimeMins}Min
                      </span>
                    </td>

                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6'>
                        {agent.resolutionPercentage}
                      </span>
                    </td>
                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6'>
                        {agent.totalConversationsResolved}
                      </span>
                    </td>
                    <td className='pe-13 text-center'>
                      <span className='text-gray-600 fw-bold fs-6'>
                        {agent.totalConversationsEscalated}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgentListing
